<template>
  <div class="metafield-edit-group">
    <slot name="dragHandle"></slot>
    <slot name="toggleBtn"></slot>
    <div class="metafield-edit-group__wrapper">
      <p class="metafield-edit-group__name" :title="renderedGroupName" :aria-title="renderedGroupName">{{ renderedGroupName }}</p>
      <TypographyInputHint v-if="hint" v-once>{{ hint }}</TypographyInputHint>
      <TypographyInputHint v-if="warning" :isDanger="true" v-once>{{ warning }}</TypographyInputHint>
    </div>
    <slot name="removeBtn"></slot>
  </div>
</template>

<script>
export default {
  props: {
    groupName: String,
    groupNameOnceRender: { type: Boolean, default: true },
    hint: String,
    warning: String,
  },

  data() {
    return {
      onceGroupName: ''
    }
  },

  computed: {
    renderedGroupName () {
      return this.groupNameOnceRender ? this.onceGroupName : this.groupName
    }
  },

  created() {
    this.onceGroupName = this.groupName
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';

  .metafield-edit-group {
    padding: 0;

    &__wrapper {
      padding: 20px 20px 20px 0;
      max-width: calc(100% - 145px);
    }
    
    &__name {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditGroup.vue